// src/pages/MainPage.js
import React, {useState} from 'react';
import styles from '../MainPage.module.css';
import talking from '../img/talking.png';
import listening from '../img/listening.png';
import { useAuth } from '../provider/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { auth } from '../firebase';
import { startListening } from '../utils/speechRecognition';
import { speak } from '../utils/textToSpeech';
import { callAPI } from '../api/callAPI';
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import Header from "../components/Header";
import WaveformOrb from "../components/WaveformOrb";

function MainPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [userInput, setUserInput] = useState('');
    const [response, setResponse] = useState('');
    const [isListening, setListening] = useState(false);
    const [isThinking, setThinking] = useState(false);
    const [isSpeaking, setSpeaking] = useState(false);
    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const [textInput, setTextInput] = useState('');

    React.useEffect(() => {
        const synth = window.speechSynthesis;

        // Function to load voices (voices may load asynchronously)
        const loadVoices = () => {
            const availableVoices = synth.getVoices();
            setVoices(availableVoices);
            if (availableVoices.length > 0 && !selectedVoice) {
                setSelectedVoice(availableVoices[0]);
            }
        };

        loadVoices();

        // Some browsers fire this event when voices are loaded asynchronously
        synth.onvoiceschanged = loadVoices;

        return () => {
            synth.onvoiceschanged = null;
        };
    }, []);


    const handleLogout = async () => {
        await signOut(auth);
        navigate('/login');
    };

    const handleVoiceInput = () => {
        setListening(true);
        startListening({
            onResult: async (transcript) => {
                setListening(false);
                setUserInput(transcript);
                setThinking(true);

                const result = await callAPI(transcript);

                setThinking(false);

                setResponse(result);

                speak(result, selectedVoice, () => setSpeaking(true), () => setSpeaking(false));


            },
            onEnd: () => setListening(false),
        });
    };

    const handleTextInput = async (e) => {
        e.preventDefault();

        setUserInput(textInput);
        setThinking(true);

        const textResponse = await callAPI(textInput);

        setThinking(false);

        setResponse(textResponse);

    }

    if (!user) {
        return <p>Please log in to access this page.</p>;
    }


    return (
        <>
        <Header />
        <Container className="py-5">
            <Card className="p-4 shadow-lg">
                <Row className="mb-4 align-items-center">
                    <Col><h4>Welcome, {user.displayName}</h4></Col>
                    <Col className="text-end">
                    </Col>
                </Row>

                <div className="mb-4">
                    <label htmlFor="voiceSelect" className="form-label">Select Charlotte's Voice:</label>
                    <select
                        id="voiceSelect"
                        className="form-select"
                        value={selectedVoice ? selectedVoice.name : ''}
                        onChange={e => {
                            const voice = voices.find(v => v.name === e.target.value);
                            setSelectedVoice(voice);
                        }}
                    >
                        {voices.map((voice, i) => (
                            <option key={i} value={voice.name}>
                                {voice.name} ({voice.lang}) {voice.default ? '- Default' : ''}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="mb-4 text-center">
                    <h4>Click to speak to Charlotte</h4>
                    <Button variant="primary" onClick={handleVoiceInput}>
                        {isListening ? <img src={listening} alt="listening icon" /> : <img src={talking}  alt="talking icon"/>}
                    </Button>
                    <div className="mt-3">

                        <WaveformOrb state={
                            isListening ? 'listening' :
                            isThinking ? 'thinking' :
                            isSpeaking ? 'speaking' :
                            'idle'
                        } />


                    </div>

                    <div>
                        <Form onSubmit={handleTextInput} className="chat-input-form">
                            <Form.Group controlId="formTextInput">
                                <Form.Label>Type to ask Charlotte a question</Form.Label>
                                <Form.Control type="text" placeholder="Type here" className="input" value={textInput} onChange={(e) => setTextInput(e.target.value)} />
                            </Form.Group>
                            <button type="submit" id="user-submit" class="btn" >Submit</button>
                        </Form>
                    </div>
                </div>

                <div>
                    <p><strong>You:</strong> {userInput}</p>
                    <p><strong>Charlotte:</strong> {response}</p>
                </div>
            </Card>
        </Container>
        </>
    );
}

export default MainPage;

